// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1971) return "static/chunks/02d30405-5eeadedc11285f81.js";
	if (chunkId === 8594) return "static/chunks/8594-5649d56fa59908ea.js";
	if (chunkId === 7581) return "static/chunks/7581-61361b657afd41d2.js";
	if (chunkId === 8137) return "static/chunks/8137-513a94ad60f9b221.js";
	if (chunkId === 3405) return "static/chunks/3405-0fa7ec0168ffc9f0.js";
	if (chunkId === 2943) return "static/chunks/2943-6468e0e7053a4c9c.js";
	if (chunkId === 7600) return "static/chunks/7600-72cf8de273d819fd.js";
	if (chunkId === 3156) return "static/chunks/3156-f3ee71cac87f7859.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"54":"1b34c61698aab779","804":"792193c2d0a8497d","1117":"cfc7bd1056d07478","1673":"0bb5c6c8741eaf80","2140":"c4b9d5fc8ea1adc5","4686":"115275b932ae91d1","5836":"13d2c07cc34099f5","9074":"b5a1e77a8099b766","9249":"ab15f87b4699c13b"}[chunkId] + ".js";
};